import '@/modules/global';
import { Header, StickyHeader } from '@/modules/header';
import PredictiveSearch from '@/modules/predictive-search';
import CartNotification from '@/modules/cart-notification';
import ResponsiveVideo from '@/modules/responsive-video';
import LazyVideo from '@/modules/lazy-video';
import FeaturedCollectionsSlider from '@/modules/featured-collections';
import MediaGridSlider from '@/modules/media-grid';
import ProductCarousel from '@/modules/product-carousel';
import NewsCarousel from '@/modules/news-carousel';
import HalfWidthCarousel from '@/modules/half-width-carousel';
import MediaCarousel from '@/modules/media-carousel';
import LogoGrid from '@/modules/logo-grid';
import FeaturedIconCarousel from '@/modules/featured-icon-carousel';
import MediaPlayback from '@/modules/media-playback';
import CollectionProductCarousel from '@/modules/collection-product-carousel';
import TabbedContentCarousel from '@/modules/tabbed-content';
import HeroUspCarousel from '@/modules/hero-usp-carousel';
import UspCarousel from '@/modules/usp-carousel';
import FeaturedProductCarousel from '@/modules/featured-product-carousel';
import QuickFilterGuide from '@/modules/quick-filter-guide';
import CarCompatibilityChecker from '@/modules/car-compatibility-checker';
import BlogCategory from '@/modules/blog-category';
import QuickLinks from '@/modules/quick-links';

import '@/modules/accordion';
import KeyboardFocus from '@/modules/keyboard-focus/keyboard-focus';

const responsiveVideos = document.querySelectorAll('.js-responsive-video');
if (responsiveVideos) {
    Array.from(responsiveVideos).forEach(el => new ResponsiveVideo(el));
}

const lazyVideos = document.querySelectorAll('.js-lazy-video');
if (lazyVideos) {
    new LazyVideo(lazyVideos);
}

new Header();

if (document.getElementsByTagName('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
}

if (document.getElementsByTagName('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}

if (document.getElementsByTagName('cart-notification')) {
    customElements.define('cart-notification', CartNotification);
}

const collectionSliders = document.querySelectorAll('.js-featured-collections-slider');
if (collectionSliders) {
    collectionSliders.forEach(el => new FeaturedCollectionsSlider(el));
}

const mediaGridSliders = document.querySelectorAll('.js-media-grid-slider');
if (mediaGridSliders) {
    mediaGridSliders.forEach(el => new MediaGridSlider(el));
}

const productSliders = document.querySelectorAll('.js-product-carousel');
if (productSliders) {
    productSliders.forEach(el => new ProductCarousel(el));
}

const newsSliders = document.querySelectorAll('.js-news-carousel');
if (newsSliders) {
    newsSliders.forEach(el => new NewsCarousel(el));
}

const halfWidthCarousel = document.querySelectorAll('.js-half-width-carousel');
if (halfWidthCarousel) {
    halfWidthCarousel.forEach(el => new HalfWidthCarousel(el));
}

const mediaCarousel = document.querySelectorAll('.js-media-carousel');
if (mediaCarousel) {
    mediaCarousel.forEach(el => new MediaCarousel(el));
}

const logoGrid = document.querySelectorAll('.js-logo-grid');
if (logoGrid) {
    logoGrid.forEach(el => new LogoGrid(el));
}

const mediaPlayback = document.querySelectorAll('.js-media-playback');
if (mediaPlayback) {
    mediaPlayback.forEach(el => new MediaPlayback(el));
}

const featuredIconsSliders = document.querySelectorAll('.js-featured-icons-carousel');
if (featuredIconsSliders) {
    featuredIconsSliders.forEach(el => new FeaturedIconCarousel(el));
}

const collectionProductCarousels = document.querySelectorAll('.js-collection-product-carousel');
if (collectionProductCarousels) {
    collectionProductCarousels.forEach(el => new CollectionProductCarousel(el));
}

const tabbedContentCarousels = document.querySelectorAll('.js-tabbed-content');
if (tabbedContentCarousels) {
    tabbedContentCarousels.forEach(el => new TabbedContentCarousel(el));
}

const heroUspCarousel = document.querySelectorAll('.js-hero-usp-carousel');
if (heroUspCarousel) {
    heroUspCarousel.forEach(el => new HeroUspCarousel(el));
}

const uspCarousel = document.querySelectorAll('.js-usp-carousel');
if (uspCarousel) {
    uspCarousel.forEach(el => new UspCarousel(el));
}

const featuredProductCarousel = document.querySelectorAll('.js-featured-product-carousel');
if (featuredProductCarousel) {
    featuredProductCarousel.forEach(el => new FeaturedProductCarousel(el));
}

const quickFilterGuide = document.querySelectorAll('.js-quick-filter-guide');
if (quickFilterGuide) {
    quickFilterGuide.forEach(el => new QuickFilterGuide(el));
}

const carCompatibilityChecker = document.querySelectorAll('.js-car-compat');
if (carCompatibilityChecker) {
    carCompatibilityChecker.forEach(el => new CarCompatibilityChecker(el));
}

const blogCategory = document.querySelectorAll('.js-blog-category');
if (blogCategory) {
    blogCategory.forEach(el => new BlogCategory(el));
}

const quickLinks = document.querySelectorAll('.js-quick-links');
if (quickLinks) {
    quickLinks.forEach(el => new QuickLinks(el));
}

new KeyboardFocus();
